module.exports = __webpack_public_path__ + "static/media/bg_3.3a12d0bd.jpg";